export class MaintenanceRunTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<MaintenanceRunType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<MaintenanceRunType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MaintenanceRunTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
